import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { useState } from "react";
import WalletManagerIcon from "src/components/WalletManagerIcon";
import { useTranslation } from "src/hooks";
import { ArrowContainer, ToggleButtonContainer } from "./sx";

interface ToggleButtonProps {
  isCollapse: boolean;
  onCollapseClick: () => void;
}

const ToggleButton = (props: ToggleButtonProps) => {
  const { onCollapseClick, isCollapse } = props;

  // boolean for animation usage
  const [isClicked, setIsClicked] = useState(false);

  const { t } = useTranslation("menu");

  const onClick = () => {
    setIsClicked(true);
    onCollapseClick();
  };

  const onAnimationEnd = () => {
    setIsClicked(false);
  };

  return (
    <ToggleButtonContainer
      isCollapse={isCollapse}
      isClicked={isClicked}
      onClick={onClick}
      onAnimationEnd={onAnimationEnd}
    >
      {isCollapse && <WalletManagerIcon />}
      <ArrowContainer isCollapse={isCollapse}>
        <ArrowDropUpIcon
          style={{
            rotate: isCollapse ? "90deg" : "270deg",
          }}
        />
        <div children={isCollapse ? t("expand") : t("collapse")} />
      </ArrowContainer>
    </ToggleButtonContainer>
  );
};
export default ToggleButton;
